import styled from 'styled-components';
import { aiBorderStackingOrderGuard } from '..';
export const StackingOrderGuard = styled.div `
  display: inline-block;
  ${aiBorderStackingOrderGuard};
`;
